export default class Regex {
  static containNumber = /[0-9]/;
  static phoneAndFax = /^[0-9]{10}$/;
  static validationFailed = /.* validation failed: /;
  static specialCharacters = /[!@#$%^&*(),.?":{}|<>]/;
  static specialCharacterWithNumbers = /[!@#$%^&*(),.?":{}|<>\d]/;
}
